// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "dynamic-imports" + "." + "bd35cd4b" + ".chunk.min.css";
};